/**
 * A soft two-tone ring drawn with Web Audio (no audio files): plays while a call rings. Browsers keep audio
 * contexts suspended until the user interacted with the page — then the ring is simply silent.
 */
export function startRingtone(): () => void {
  const AudioContextClass = window.AudioContext as typeof AudioContext | undefined;
  if (!AudioContextClass) return () => undefined;
  let context: AudioContext;
  try {
    context = new AudioContextClass();
  } catch {
    return () => undefined;
  }
  let stopped = false;
  const ring = () => {
    if (stopped || context.state === 'closed') return;
    const now = context.currentTime;
    for (const [offset, frequency] of [
      [0, 660],
      [0.18, 880],
      [0.6, 660],
      [0.78, 880],
    ] as const) {
      const oscillator = context.createOscillator();
      const gain = context.createGain();
      oscillator.type = 'sine';
      oscillator.frequency.value = frequency;
      gain.gain.setValueAtTime(0, now + offset);
      gain.gain.linearRampToValueAtTime(0.08, now + offset + 0.02);
      gain.gain.linearRampToValueAtTime(0, now + offset + 0.16);
      oscillator.connect(gain).connect(context.destination);
      oscillator.start(now + offset);
      oscillator.stop(now + offset + 0.17);
    }
  };
  void context.resume().catch(() => undefined);
  ring();
  const timer = setInterval(ring, 2600);
  return () => {
    stopped = true;
    clearInterval(timer);
    void context.close().catch(() => undefined);
  };
}
